import { FormGroup } from '@angular/forms';
import { Screen, ScreenAction, ScreenMap } from './screen.constants';
import { ContextService } from '../core/context.service';
export class Constants {
  public readonly Screen = Screen;

  public readonly ScreenAction = ScreenAction;

  public readonly ScreenMap = ScreenMap;

  public readonly KycType = {
    New: 1,
    Update: 2,
  };

  public readonly KycAccountType = {
    NormalOVD: 1,
    SimplifiedNon_OVD: 2,
    SmallWithoutOVD: 3,
    QuickID: 4,
    Cancelled: 5
  };

  public readonly ProofOfIdentity = {
    PassportNumber: 1,
    VoterIDCard: 2,
    PANCard: 3,
    DrivingLicence: 4,
    //NationalId: 5,
    Aadhaar: 5,
    NREGAJobCard: 6,
    Others: 7,
    Photo: 8,
    Signature: 9,
    KebeleID:10,
    TINNumber:11,
    StudentID:12,
    OfficeID:13,
    RegistrationId:14,
  };


  public readonly DocumentType = {
    PassportNumber: 1,
    DrivingLicence: 4,
    NationalID : 5,
    Photo: 8,
    Signature:9,
    TINNumber:11,
    KebeleID:10,
    StudentID:12,
    AuthorisedSignatory:14,
 	  OrgRegID:13
  };

    public readonly AssetClassification = {
    //  Unknown : 0,
    Standard: 1,
    Substandard: 2,
    Doubtful: 3,
    WriteOff: 4,
  };

  public OccupationType = {
    Unknown: 0,
    Student: 1,
    Professional: 2,
    SelfEmployed: 3,
    Retired: 4,
    Housewife: 5,
    Teachers: 6,
    Business: 7,
    NotCategorised: 8,
    ServicePublicSector: 10,
    ServicePrivateSector: 11,
    SSB: 12,
    Pensioners: 13,
    Staff: 14,
  };

    public readonly DocumentsType = {
    Unknown: 0,
    LegalProceess: 1,
    Vehicle: 2,
    Gold: 3,
    Land: 4,
    Insurance: 5,
    Employee: 6,
  };
  public readonly PhoneType = {
    Office: 1,
    Residencial: 2,
    MobileNumber: 3,
    Fax: 4,
    SpousePhoneNumber: 5,
    NextOfKinPhoneNumber: 6,
    RelatedPartiesPhoneNumber: 8,
    LandLineNumber: 7,
  };

  public readonly TransactionEntityType = {
    Account: 1,
    GeneralLedger: 2,
    CustomerId: 3
  };

  public readonly EntityStatusList = {
    Active: 'Active',
    InActive: 'A/c InActive',
    Deleted:'Deleted',
    Closed:'A/c Closed',
    Dormant:'Dormant',
    Frozen:'Frozen',
  };

  public readonly EntityStatus = {
    Active: 1,
    InActive: 2,
    Deleted:3,
    Closed:4,
    Dormant:5,
    Frozen:6
  };

  public readonly DebitOrCredit = {
    Debit: 1,
    Credit: 2
  };

  public readonly Gender = {
    Male: 1,
    Female: 2,
    Transgender: 3,
    Non_Individual: 4
  };

  public readonly casteCategory = {
    General: 1,
    SC: 2,
    ST: 3,
    OBC: 4
  };
  public readonly AccountJoint = {
    GenerateNewId: 1,
    ExistingId: 2
  };

  public readonly SearchType = {
    All: 0,
    WithAccount: 1,
    WithoutAccount: 2,
    Cancelled: 3
  };

  public readonly ChequeBookStatus = {
    Yes: 'Yes',
    No: 'No'
  };

  public readonly IsYesOrNo = {
    Yes: 'Yes',
    No: 'No'
  };

  public readonly CashGeneralLedgerId = 1;
  public readonly CashGeneralLedgerCode = '1001';
  public readonly CashGeneralLedgerDescription = 'Cash';

  public readonly TrustTransactionGeneralLedgerId = 1;
  public readonly TrustTransactionGeneralLedgerCode = '1001';
  public readonly TrustTransactionGeneralLedgerDescription = 'Trust';

  public readonly PaymentModeList = [
    { id: 8, name: 'RTGS' },
    { id: 7, name: 'NEFT' },
    { id: 6, name: 'Cheque' },
    { id: 5, name: 'IBT' },
    { id: 4, name: 'Bank' },
    { id: 3, name: 'CASA' },
    { id: 2, name: 'Suspense' },
    { id: 1, name: 'Cash' },
  ];

  public readonly PaymentMode = {
    Cash: 1,
    Suspense: 2,
    CASA: 3,
    Bank: 4,
    IBT: 5,
    Cheque: 6,
    NEFT: 7,
    RTGS: 8
  };

  public LoanPoupType = {
    Principal: 1,
    Interest: 2,
    PenalInterest: 3,
    Charges: 4,
    InterestableCharges: 5,
    InterestOnCharges: 6,
    BrokenPeriodInterest: 7,
    BrokenPeriodInterestOnCharges: 8
  };

  public AuthorisedStatus = {
    Authorised: 'Authorised',
    UnAuthorised: 'UnAuthorised'
  };

  public GeneralLedgerFor = {
    BankGL: 'Bank GL',
    CustomerGL: 'Customer GL'
  };

  public TDInterestFrequency = {
    Monthly: 1,
    Quarterly: 2,
    HalfYearly: 3,
    Yearly: 4,
    OnMaturity: 5,
    All: 6,
  };

  public RDInterestFrequency = {
    Monthly: 1,
    Quarterly: 2,
    HalfYearly: 3,
    Yearly: 4,
    OnMaturity: 5,
    All: 6,
  };

  public InterestFrequency = {
    Monthly: 1,
    Quarterly: 2,
    HalfYearly: 3,
    Yearly: 4,
    Fortnightly: 5,
    Weekly: 6,
    Daily: 7
  };

  public TransactionSource = {
    Unknown: 0,
    WebApp: 1,
    MobileApp: 2,
    Neft: 3,
    Atm: 4
  };

  public readonly TransactionType = {
    Unknown: 0,
    Cash: 1,
    Transfer: 2,
    Clearing: 3
  };

  public readonly TransactionEvent = {
    Unknown: 0,
    SharesInitialPurchase: 1,
    SharesAdditionalPurchase: 2,
    LoanInitialDisbursement: 3,
    LoanAdditionalDisbursement: 4,
    LoanRepaymentRegular: 5,
    LoanRepaymentBrokenPeriod: 6,
    OverdraftAccountOpening: 7,
    CasaAccountOpening: 8,
    CasaTransaction: 9,
    Transfer: 10,
    CashTransfer: 11,
    TermDepositAccountOpening: 12,
    TermDepositInterestPayment: 13,
    TermDepositClosurePayment: 14,
    TermDepositOnMaturityPayments: 15,
    PigmyAgentCollection: 16,
    PigmyWithdrawalPayment: 17,
    ShareRefund: 18,
    RecurringWithdrawalPayment: 19,

    IBT: 100
  };

  public readonly TransactionOperation = {
    Unknown: 0,
    ShareAmount: 1,
    ShareFees: 2,
    ShareFeesGst: 3,
    ShareApplicationFees: 4,
    ShareApplicationFeesGst: 5,
    ShareAdmissionFees: 6,
    ShareAdmissionFeesGst: 7,
    ShareOtherCharges: 8,
    ShareOtherChargesGst: 9,
    ShareDeathReliefFund: 10,
    ShareInsurance: 11,
    ShareInsuranceGst: 12,

    LoanProcessingFees: 20,
    LoanProcessingFeesGst: 21,
    LoanAdditionalShareAmount: 22,
    LoanAdditionalShareFees: 23,
    LoanAdditionalShareFeesGst: 24,
    LoanDisbursement: 25,
    LoanPrincipalRepaid: 26,
    LoanInterestRepaid: 27,
    LoanPenalInterestRepaid: 28,
    LoanChargesRepaid: 29,
    LoanInterestOnChargesRepaid: 30,
    LoanRebate: 31,

    CasaMinimumBalance: 40,
    CasaDeposit: 41,
    CasaWithdrawal: 42,

    TermDepositAmount: 50,
    TermDepositInterestAmount: 51,
    TermDepositInterestRecovery: 52,
    TermDepositClosureAmount: 53,
    TermDepositTdsAmount: 54,
    TermDepositMaturityAmount: 55,
    TermDepositMaturityInterest: 56,

    PigmySuspenseAmount: 57,
    PigmyAccountAmount: 58,
    PigmyWithdrawalAmount: 59,
    PigmyWithdrawalPenalty: 60,
    PigmyWithdrawalPenaltyGst: 61,

    RecurringWithdrawalAmount: 62,

    Transfer: 100,
    CashDeposit: 101,
    CashWithdrawal: 102,

    IBTAsset: 501,
    IBTLiability: 502
  };

  public ApplicationModule = {
    Unknown: 0,
    Shares: 1,
    ReserveFund: 2,
    Borrowings: 3,
    SavingsAccount: 4,
    CurrentAccount: 5,
    FixedDeposit: 6,
    ReInvestment: 7,
    RecurringDepositFixed: 8,
    RecurringDepositVariable: 9,
    Pigmy: 10,
    OtherLiabilities: 11,
    DDPO: 12,
    NEFT: 13,
    Dividend: 14,
    Cash: 15,
    BankAccount: 16,
    Investment: 17,
    LoanRBM: 18,
    LoanEMI: 19,
    LoanFlat: 20,
    Overdraft: 21,
    OtherAssets: 22
  };

  public  ReportsType = {
    Unknown : 0,
        DayBook1Report : 1,
        DayBook2Report : 2,
        SubDayBookReport :3,
        BalanceSheetReport : 4,
        ScheduleReport : 6,
        CashScrollReport : 7,
        DcbReport : 8,
        ProfitAndLossReport : 9,
        TransferScrollReport :10,
        TrialBalanceReport :11,
        ScheduleWithReceiptsandPpayment: 12,
        AccountStatusReport :13,
        CustomerDetails :14,
        DeleteTransaction : 15,
        AccrualLoanInterestPaymentDetails : 17,
        AccrualSavingsInterestPaymentDetails : 18,
        LoanAccountsDueBucketBise :19,
        LoanAccountDeteails :20,
        LoanAccounStatement :21,
        MonthEndNetBalanceDetails : 22,
        MonthEndPenaltyDetails : 23,
        MonthlyLoanRepaymentDetails :24,
        OtherReceivablePenaltydetails : 25,
        OtherReceivableSocialContribution : 26,
        ProductwiseAccountDetails: 27,
        ShareDividendReport: 28,
        SocialContribution : 29,
        CasaMonthlyInterestPayment : 30,
        UserHistory:31,
        AuditLog:32,
        OpenedShareAccounts:33,
        LienReport:34,
        YearendReport : 38,
        ProvisionReport :37,
        LoanRepaymentReport:35,
        InterfaceTransactionReport:36,
        NetBalance:39,
        ERPReport :40,
        DeleteAccountsReport:41,
        CustomerDashBoard:42,
        CasaAccountDashBoard : 43,
        ShareAccountDashBoard : 44,
        LoanAccountDashBoard :45,
        DailyLoanDcbReport :46,
        UserDetails:47,
        InterfaceApplicationReqReport:48,
        AgmAttendance:49,
         PigmyAccountDashBoard:56,
         TermDepositAccountDashBoard:57,
         RecurringAccountDashBoard:58,
         OverdraftAccountDashBoard:59,
         DisbursedDashboardData :90,
          CollectionDashboardData :91,
          PendingApprovalDashboardData : 92,
          DisbursedGraphDashboardData : 136,
       CollectionGraphDashboardData : 137,
         AccountSummaryGraphDashboardData : 138,
    MaturityProfile: 100,
    GenderDistribution:102,
    Top30Borrower:98,
     SectorExposure: 99,
     ScheduleAssetQuality: 101,
     CustomerDashBoardGraph:136,  // financial_dashboard
    AccountSummaryDashboardGraph: 137,
    ScheduleForRpt:97,
       LoanOutstandingPortfolioReport: 105,
       InterestIncomeReport:106,
        LoanRestructure:109,
        EodInformation:110,
        SMSPopupReportAccountNo:119,
        LoanAccrualSavedReport:121
  

  };


  public readonly operationType = {
    SingleIndividual: 1,
    Jointly: 2,
    EitherOrSurviour: 3,
    FormerOrSurviour: 4,
    AnyoneOrSurviour: 5,
    Mandate: 6,
    PowerOfAttorney: 7,
    Severally: 8,
    MionrJointAccount: 9
  };

  public readonly AddressTypes = {
    ResidentialBusiness: 1,
    Residential: 2,
    Business: 3,
    RegisteredOffice: 4,
    Unspecified: 5
  };

  public readonly AddressTypeNames = {
    ResidentialBusiness: 'Residential Business',
    Residential: 'Residential',
    Business: 'Business',
    RegisteredOffice: 'Registered Office',
    Unspecified: 'Unspecified'
  };

  public readonly TellerStatus = {
    Unknown: 0,
    NewAccount: 1,
    Payable: 2,
    ToPay: 3,
    Paid: 4,
    ToReceive: 5,
    Received: 6,
    Approved: 7,
    Deleted: 8,
    OpeningCash: 9,
    ClosingCash: 10,
    TransferedTo: 11,
    TransferedFrom: 12
  };

  public readonly TellerStatusNames = {
    Unknown: 'Unknown',
    NewAccount: 'New Account',
    Payable: 'Payable',
    ToPay: 'To Pay',
    Paid: 'Paid',
    ToReceive: 'To Receive',
    Received: 'Received',
    Approved: 'Approved',
    Deleted: 'Deleted',
    OpeningCash: 'Opening Cash',
    ClosingCash: 'Closing Cash',
    TransferedTo: 'Transfered To',
    TransferedFrom: 'Transfered From'
  };

  public readonly LinkTypes = {
    Unknown: 0,
    SavingsAcJointSignatory: 1,
    SavingsAcInActiveJointHolder: 2,
    CurrentAcJointSignatory: 3,
    CurrentAcInActiveJointHolder: 4,
    TermDepositAcJointSignatory: 5,
    TermDepositAcInActiveJointHolder: 6,
    NaturalGuardianAcOperatorofMinor: 7,
    NaturalGuardianJointsignatoryofMinorAc: 8,
    PowerofAttorneyHolderAcOperator: 9,
    PowerofAttorneyJointOperator: 10,
    NonIndividualAcSignatory: 11,
    LoanAcJointHolderWhenPropertyisInJointNames: 12,
    LoanAcJointCoBorrower: 13,
    AuthorisedSignatory: 14,
    President: 15,
    VicePresident: 16,
    Treasurer: 17,
    Director: 18,
    CEO: 19,
    GeneralManager: 20,
    Manager: 21,
    Accountant: 22,
    AcNominee: 101,
    LoanAcSurety: 102,
    AccountIntroducer: 103,
    CourtAppointee: 104,
    Guarantor: 105,
    Agent: 106,
    BusinessAssociate: 107,
    AcceptedRecommender: 108,
  };

  public readonly AccountHolderTypes = {
    NotRequired: 6
  };

  public PenaltyType = {
    None: 0,
    Flat: 1,
    Percent: 2
  };

  public ProcessingFeeType = {
    Flat: 1,
    Percent: 2
  };

  public readonly SpecialSearch = {
    Unknown: 0,
    CasaAccountsForOverdraft: 1,
  };

  public readonly LoanProcessingMode = {
    Collect: 1,
    Deduct: 2
  };

  public readonly LoanRecoveryTypes = {
    Unknown: 0,
    RegularDues: 1,
    UptoDateInterest: 2
  };

  public readonly LoanInterestType = {
    Unknown: 0,
    Fixed: 1,
    Floating: 2,
    Flat: 3
  };

  public readonly LoanRepaymentType = {
    Unknown: 0,
    EMILoan: 1,
    RBMLoan: 2,
    BulletRepayment: 3,
    Flat: 4
  };

  public PigmyWithdrawalType = {
    FullWithdrawal: 1,
    PartialWithdrawal: 2
  };

  public readonly Narrations = {
    DebitCash: 601,
    DebitTransfer: 602,
    CreditCash: 801,
    CreditTransfer: 802,
  };

  public readonly LoanDcbEvents = {
    Unknown: 0,
    InitialDisbursement: 1,
    DemandDue: 2,
    BrokenPeriodDemandDue: 3,
    PaymentAgainstDues: 4,
    LoanCharges: 5,
    ChangeOfInterest: 6,
    AdditionalDisbursement: 7,
    Enhancement: 8,
    IncomeProjection: 9
  };

  public readonly ClearingProcessStatus = {
    Unknown: 0,
    InProcess: 1,
    Realised: 2,
    Rejected: 3,
  };

  public readonly LoanRepaymentChequeStatus = {
    Unknown: 0,
    Submitted: 1,
    InProcess: 2,
    Processed: 3,
  };

  public readonly ClearingWindowType = {
    Unknown: 0,
    Inward: 1,
    Outward: 2,
  };

  public readonly NumberOfAuthorisations = [
    { id: 1, name: '1. One' },
    { id: 2, name: '2. Two' },
    { id: 3, name: '3. Three' },
    { id: 4, name: '4. Four' }
  ];

  public readonly FurtherDepositAccountProcessTypes = [
    { id: 1, name: 'Update Account Details' },
    { id: 2, name: 'Close Before Maturity' },
    { id: 3, name: 'Close On Or After Maturity' },
    { id: 4, name: 'Full Renewal' },
    { id: 4, name: 'Partial Renewal' },
    { id: 4, name: 'Addithonal Renewal' }
  ];

  public readonly DepositProcessType = {
    Unknown: 0,
    UpdateAccount: 1,
    PreCloseAccount: 2,
    CloseAccount: 3,
    Renewal: 4
  };

  public readonly FurtherRecurringDepositAccountProcessTypes = [
    { id: 1, name: 'Update Account Details' },
    { id: 2, name: 'Close Before Maturity' },
    { id: 3, name: 'Close On Or After Maturity' }
  ];

  public readonly LienType = {
    Unknown: 0,
    Bank_Society_Loan: 1,
    CourtOrder: 2,
    IncomeTaxInstructions: 3,
    Anti_MoneyLaundering: 4,
    FullFreeze: 5
  };

  public readonly DepositTypes = {
    FixedDeposit: 1,
    ReInvestment: 2,
    CashCertificate: 3,
    DoubleCertificate: 4
  };

  public readonly RDDepositTypes = {
    FixedDeposit: 1,
    VariableDeposit: 2,
    FixedAndVariable: 3
  };

  public readonly GeneralLedgerTypes = {
    Unknown: 0,
    Asset: 1,
    Liability: 2,
    Income: 3,
    Expense: 4
  };

  public readonly currency_option = [
    { name: "INR", value: 1, currencyRate: 1.00, symbol: "₹" },
    { name: "USD", value: 2, currencyRate: 81.88, symbol: "$" },
    { name: "KES", value: 3, currencyRate: 1.47, symbol: "KSh" },
    { name: "JPY", value: 4, currencyRate: 1.77, symbol: "¥" },
    { name: "PHP", value: 5, currencyRate: 0.72, symbol: "₱" },
    { name: "INR", value: 6, currencyRate: 1.00, symbol: "₹" },
    { name: "ETB", value: 7, currencyRate: 81.88, symbol: "ብር" },
    { name: "ADP", value: 8, currencyRate: 1.47, symbol: "ADP" },
    { name: "AFN", value: 9, currencyRate: 1.77, symbol: "AFN" },
    { name: "AOA", value: 10, currencyRate: 0.72, symbol: "Kz" },
    { name: "BDT", value: 11, currencyRate: 1.00, symbol: "৳" },
    { name: "CRC", value: 12, currencyRate: 81.88, symbol: "₡" },
    { name: "EGP", value: 13, currencyRate: 1.47, symbol: "E£" },
    { name: "FKP", value: 14, currencyRate: 1.77, symbol: "£" },
    { name: "GEL", value: 15, currencyRate: 0.72, symbol: "₾" },
  ]
  ReportType: any;
  public convertWithCurrencyRate(value: number, currency: string) {
    let currencyRate = this.currency_option.find(f => f.name === currency).currencyRate;
    if (currencyRate)
      return value * currencyRate;
    return value;
  }
  public formatCurrency(form: FormGroup, formControlName, selectedCurrency, decimalDigit, numberFormat) {
    let value = form.get(formControlName).value;
    this.currency_option.forEach((element) => {
      value = value.toString().replace(element.name, '').replace(element.symbol, '').replace(/\,/g, '');
    });
    let currency = this.currency_option.filter((x) => x.value === selectedCurrency);
    if (value && !isNaN(value)) {
      let num: number = value;
      let result = new Intl.NumberFormat(numberFormat, {
        style: 'currency',
        currency: currency[0].name,
        minimumFractionDigits: decimalDigit,
      }).format(Number(num));
      form.get(formControlName).setValue(result);
    }
  }
  // public removeCurrencySymbol(form: FormGroup, formControlName)
  // {
  //   let value = form.get(formControlName).value;
  //   this.currency_option.forEach((element) => {
  //     value = value.toString().replace(element.name, '').replace(element.symbol, '').replace(/\,/g, '').replace(' ', '');
  //   });

  //   form.get(formControlName).setValue(parseFloat(value));
  // }

  public removeCurrencySymbol(form: FormGroup, formControlName)
  {
    let value = form.get(formControlName).value;
    this.currency_option.forEach((element) => {
      value = value.toString().replace(element.name, '').replace(element.symbol, '').replace(/\,/g, '').replace(' ', '');
    });

 form.get(formControlName).setValue(parseFloat(value));
  }

}

export class Formats {
  readonly SERIALISATION_FORMAT = 'YYYY-MM-DD';
  readonly DATE_FORMAT = 'dd-MM-yyyy';
  readonly DATE_TIME_FORMAT = 'dd-MM-yyyy HH:mm:ss.SS';
  readonly INDIAN_CURRENCY = 'INR';
}

export class ValidatorExpressions {
  readonly PERCENT_EXPRESSION = '^[0-9]{1,2}(\\\.[0-9]{1,2})?$';
  readonly AMOUNT_EXPRESSION = '^[0-9]{1,11}(\\\.[0-9]{1,2})?$';
  readonly NUMBER_EXPRESSION = '^[0-9]*';
  readonly ATM_TRANSACTION_EXPRESSION = '^[0-9]*';
  readonly PAN_CARD_NUMBER = '^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$';
  // readonly AADHAAR = '^[0-9]{12}';
  readonly AADHAAR = "^\\d{8,9}[a-zA-Z]\\d{2}$";
  readonly DRIVING_LICENCE = '^[a-zA-Z]{2}[0-9]{13}$';
  readonly VOTER_ID = '^[a-zA-Z]{3}[0-9]{7,11}$';
  readonly MOBILE_NUMBER = '^[0-9]{9}';
  readonly EMAIL = '[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$';
  readonly PIN_CODE = '^[1-9][0-9]{5}$';
  readonly CHEQUE_EXPRESSION = '^[0-9]{6}$';
   readonly PASSPORT_ID = "^[a-zA-Z]{2}\\d{6}$";

}
